import { Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import React from "react";
import CardSys from "../../components/cardSys";
import TableUsers from "../../components/tableUsers";
import TitlePages from "../../components/generic/titlePages";
import ButtonCreate from "../../components/buttonCreate";
import ModalSys from "../../components/modal";
import CreateUser from "../../components/createUser";
import EditUser from "../../components/editUser";
import FilterTableSys from "../../components/filterTableSys";
import { api } from "../../services/api";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import ButtonControlPermission from "../../components/buttonControlPermission";

export default function Users() {

  const [modal, setModal] = useState(false)
  const [updateTable, setUpdateTable] = useState(false)
  const [userEdit, setUserEdit] = useState(false)
  const [users, setUsers] = useState([]);
  const [usersView, setUsersView] = useState([]);
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const { user } = useContext(AuthContext)
  const navigate = useNavigate();

  
  const [search,setSearch] = useSearchParams()

  const createUser = search.get('create')

  const { id: idPage  } = useParams();

  const permissionUser = [];

  user?.permission?.map((el) => {
    if (el.name == "Usuários") {
      permissionUser.push(...el.permission);
    }
  });

  useEffect(() => {
    if (user?.id) {
      if (!permissionUser.find((el) => el.name == "Visualizar") || (user?.id_client != 25886008 && user?.master !== 1 ) ) {
        navigate("/notpermission")
      }
    }
  }, [user])

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    if (!!idPage) {
      if (!isNaN(idPage / 2)) {
        setModal(true)
        setUserEdit({ id: idPage })
      } else {
        navigate("/notpermission")
      }
    }
  }, [idPage])


  useEffect(() => {
    if (!!createUser) {
        setModal(true)
        setUserEdit(false)
    }
  }, [createUser])


  useEffect(() => {
    getUsers();
  }, [updateTable]
  );

  async function getUsers() {
    handleLoading(true);

    try {
      const { data } = await api({ method: "GET", url: "/user" });
      data.map(el => {
        el.cre_ativo = el.status
      })
      setUsers(data)
      setUsersView(data);
      // setModal(false);
    //  console.log(JSON.stringify(data))
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  }

  const handleFilter = (value) => {
    if (value == "") {
      setUsersView(users)
    } else {
      const listView = []
      users.map(el => {
        const items = Object.values(el)
        const compare = []
        items.map(item => {
          if (item) {
            compare.push(item.toString())
          }
        })
        if (!!compare.find(item => item.toUpperCase().includes(value.toUpperCase()))) {
          listView.push(el)
        }
      })
      setUsersView(listView)
    }
  }

  return (
    <>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item>
          <TitlePages>Usuários</TitlePages>
        </Grid>
      </Grid>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item xs={12}>
          <FilterTableSys handleFilter={value => handleFilter(value)}>
          </FilterTableSys>
        </Grid>
      </Grid>
      <CardSys>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            xs={6}
            direction="row"
            justifyContent="end"
            alignItems="end"
            sx={{ display: "flex" }}
          >
          </Grid>

          <Grid
            item
            xs={6}
            direction="row"
            justifyContent="end"
            alignItems="end"
            sx={{ display: "flex" }}
          >
            <ButtonCreate sx={{color:"white",backGroundColor:"#2C4992",textTransform: "initial",padding:"6px",marginRight:"9px"}} 
              onClick={() => { setModal(true); setUserEdit(false) }}
            >
               Cadastrar novo usuário
            </ButtonCreate>
            {user?.id_client == 25886008 && 
              <ButtonControlPermission onClick={() => navigate('/permission')}></ButtonControlPermission>
            }
          </Grid>
          <Grid
            item
            xs={12}
            direction="row"
            justifyContent="center"
            alignItems="center"
            marginTop={"15px"}
          >
            <TableUsers getUsers={getUsers} users={usersView} handleEdit={(value) => { setModal(true); setUserEdit(value) }}></TableUsers>
          </Grid>
        </Grid>
      </CardSys>
      <ModalSys open={modal} handleClose={() => setModal(false)}>
        {!userEdit ? (
          <CreateUser updateTable={() => setUpdateTable(!updateTable)} userEdit={userEdit} handleClose={() => setModal(false)}>
          </CreateUser>
        ) : (
          <EditUser updateTable={() => setUpdateTable(!updateTable)} handleClose={() => setModal(false)} userEdit={userEdit} >
          </EditUser>
        )}
      </ModalSys>
    </>
  );
}
